import { useState } from 'react';
import VideoModal from '@/pages/home/components/VideoModal';

export default function VideoBanner() {
  const [open, setOpen] = useState(false);

  return (
    <section className="relative overflow-hidden bg-secondary-950">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20cinematic%20dark%20teal%20medical%20backdrop%20with%20soft%20bokeh%20lights%20and%20blurred%20modern%20clinic%20interior%2C%20deep%20emerald%20and%20charcoal%20tones%2C%20subtle%20glowing%20particles%2C%20elegant%20editorial%20healthcare%20branding%20aesthetic%2C%20moody%20atmospheric%20lighting%2C%20clean%20minimal%20composition%20with%20strong%20contrast%20for%20white%20text%20overlay&width=1920&height=900&seq=medicaclic-videobanner-01&orientation=landscape"
        alt="Découvrir MEDICACLIC en vidéo"
        title="Découvrir MEDICACLIC en vidéo"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/95 via-secondary-900/85 to-secondary-900/55" />

      <div className="relative z-10 px-4 md:px-8 lg:px-12 pt-28 pb-10 md:pt-32 md:pb-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-accent-300 mb-4">
              <i className="ri-play-circle-line text-base w-4 h-4 flex items-center justify-center" />
              MEDICACLIC en vidéo
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-background-50 leading-tight mb-4">
              Découvrez la plateforme<br />
              <span className="italic text-primary-300">en moins d'une minute.</span>
            </h2>
            <p className="text-sm md:text-base text-background-200 max-w-lg leading-relaxed mb-7">
              Prendre rendez-vous, chercher un laboratoire, recevoir une confirmation :
              voyez en 40 secondes comment MEDICACLIC simplifie l'accès aux soins au Maroc.
            </p>
            <button
              onClick={() => setOpen(true)}
              className="inline-flex items-center gap-2.5 px-6 py-3.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-fill text-lg w-5 h-5 flex items-center justify-center" />
              Découvrir le site en vidéo
            </button>
          </div>

          <button
            onClick={() => setOpen(true)}
            aria-label="Découvrir le site en vidéo"
            className="group relative block w-full rounded-xl overflow-hidden border border-background-50/15 cursor-pointer aspect-video"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Bright%20modern%20medical%20clinic%20consultation%20room%20in%20Morocco%20with%20warm%20natural%20daylight%2C%20friendly%20doctor%20desk%2C%20green%20plants%2C%20clean%20minimal%20teal%20and%20cream%20interior%20design%2C%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20welcoming%20professional%20healthcare%20editorial%20photography&width=1200&height=675&seq=medicaclic-videoposter-01&orientation=landscape"
              alt="Aperçu de la vidéo de présentation MEDICACLIC"
              title="Aperçu de la vidéo de présentation MEDICACLIC"
              className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute inset-0 bg-foreground-950/30 group-hover:bg-foreground-950/40 transition-colors" />
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-background-50/95 group-hover:scale-110 transition-transform">
                <i className="ri-play-fill text-3xl md:text-4xl text-primary-600 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center" />
              </span>
            </span>
            <span className="absolute bottom-3 left-3 px-3 py-1.5 rounded-md bg-foreground-950/70 text-background-50 text-xs font-medium whitespace-nowrap">
              40 s · Sous-titres FR
            </span>
          </button>
        </div>
      </div>

      {open && <VideoModal onClose={() => setOpen(false)} />}
    </section>
  );
}